import { render } from "./IntentsNew.vue?vue&type=template&id=5ac327a0&scoped=true&lang=pug"
import script from "./IntentsNew.js?vue&type=script&lang=js&external"
export * from "./IntentsNew.js?vue&type=script&lang=js&external"

import "./IntentsNew.vue?vue&type=style&index=0&id=5ac327a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac327a0"]])

export default __exports__